import { assetPath } from "./assets";

export const DEFAULT_LANGUAGE_OPTION = {
    id: null,
    apiCode: "id",
    code: "ID",
    i18nCode: "id",
    name: "ID",
    iconSrc: assetPath("/icons/id.png"),
};

const LANGUAGE_ICON_CODE_OVERRIDES = {
    en: "us",
    en_us: "us",
    cn: "cn",
    zh: "cn",
    zh_cn: "cn",
    jp: "jp",
    ja: "jp",
    ja_jp: "jp",
    kr: "kr",
    ko: "kr",
    ar: "sa",
    fa: "ir",
};

const I18N_LANGUAGE_CODE_OVERRIDES = {
    cn: "zh",
    zh_cn: "zh",
    jp: "ja",
    ja_jp: "ja",
    kr: "ko",
};

const STORAGE_LANGUAGE_CODE_OVERRIDES = {
    zh: "CN",
    ja: "JP",
    ko: "KR",
};

export const normalizeLanguageCode = (code = "") => (
    String(code || "").trim().toLowerCase().replace("-", "_")
);

export const getI18nLanguageCode = (code = "") => {
    const normalizedCode = normalizeLanguageCode(code);
    return I18N_LANGUAGE_CODE_OVERRIDES[normalizedCode]
        || (normalizedCode ? normalizedCode.split("_")[0] : DEFAULT_LANGUAGE_OPTION.i18nCode);
};

export const getLanguageStorageCode = (code = "") => {
    const normalizedCode = normalizeLanguageCode(code);
    const i18nCode = getI18nLanguageCode(normalizedCode);

    return STORAGE_LANGUAGE_CODE_OVERRIDES[i18nCode]
        || (normalizedCode ? normalizedCode.split("_")[0].toUpperCase() : DEFAULT_LANGUAGE_OPTION.code);
};

export const getLanguageIconSrc = (code = "") => {
    const normalizedCode = normalizeLanguageCode(code);
    const iconCode = LANGUAGE_ICON_CODE_OVERRIDES[normalizedCode] || normalizedCode.split("_").pop();

    return assetPath(`/icons/${iconCode || "id"}.png`);
};

export const buildLanguageOptions = (languageList = []) =>
    languageList
        .filter((lang) => lang?.code)
        .map((lang) => {
            const apiCode = normalizeLanguageCode(lang.code);
            const i18nCode = getI18nLanguageCode(apiCode);

            return {
                id: lang.id,
                apiCode,
                code: getLanguageStorageCode(apiCode),
                i18nCode,
                name: lang.name || getLanguageStorageCode(apiCode),
                iconSrc: getLanguageIconSrc(apiCode),
            };
        });
